import axios from "axios";

// 🔄 DEV/TEST: true
// 🔄 PROD/LIVE: false
let IS_DEV_ESIM = false;

const ESIM_API_URLS = {
  dev: "http://10.40.1.89:8000",
  prod: "https://esim.globtel.biz/api",
};

const getEsimApiUrl = () =>
  IS_DEV_ESIM ? ESIM_API_URLS.dev : ESIM_API_URLS.prod;

export const esimPublicApiClient = axios.create({
  baseURL: getEsimApiUrl(),
});

export const esimPrivateApiClient = axios.create({
  baseURL: getEsimApiUrl(),
});

esimPrivateApiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

const handleError = (error) => {
  if (error.response?.status === 401) {
    localStorage.removeItem("token");
    window.location.href = "/sign-in";
    return Promise.reject(error);
  }
  if (!error.response?.status && error.request) {
    error.status = error.request.status;
    error.response = {
      status: error.request.status,
      data: error.response?.data || {},
    };
  }
  return Promise.reject(error);
};

esimPublicApiClient.interceptors.response.use(
  (response) => response,
  handleError,
);
esimPrivateApiClient.interceptors.response.use(
  (response) => response,
  handleError,
);

export default {
  esimPublicApiClient,
  esimPrivateApiClient,
};
